import {
  REPORTS_ENQUADRAMENTO_REGRAS_CHANGED,
  REPORTS_ENQUADRAMENTOS_CHANGED,
  REPORTS_LOGOUT,
} from "../../const/actionsType";

export function acReportsEnquadramentoRegrasChanged(pData) {
  return {
    type: REPORTS_ENQUADRAMENTO_REGRAS_CHANGED,
    payload: pData,
  };
}

export function acReportsEnquadramentosChanged(pData) {
  return {
    type: REPORTS_ENQUADRAMENTOS_CHANGED,
    payload: pData,
  };
}

export function acReportsLogout() {
  return {
    type: REPORTS_LOGOUT,
  };
}
